import ApiService from './ApiService'
import {
  CreateShredRequest,
  Shred,
  ShredResponse,
  GenerateShredPromptResponse
} from "@/@types/shred";

export async function apiGetShred(
  shredId: string | undefined
) {
  return ApiService.fetchData<Shred>({
    url: `api/shreds/${shredId}`,
    method: 'get',
  })
}

export async function apiGetShredProgress(
  shredId: string | undefined
) {
  return ApiService.fetchData<ShredResponse>({
    url: `api/shreds/${shredId}/progress`,
    method: 'get',
  })
}

export async function pushShredToRepo(
  shredId: string | undefined
) {
  return ApiService.fetchData<void>({
    url: `api/shreds/${shredId}/push`,
    method: 'post',
  })
}

export async function apiStopShred(
  shredId: string | undefined
) {
  return ApiService.fetchData<ShredResponse>({
    url: `api/shreds/${shredId}/stop`,
    method: 'post',
  })
}

export async function apiCreateShred(
  serviceId: string | undefined,
  data: CreateShredRequest
) {
  return ApiService.fetchData<ShredResponse>({
    url: `api/services/${serviceId}/shred`,
    method: 'post',
    data,
  })
}

export async function apiValidateDescription<T, U extends Record<string, unknown>>(
  shredId: string,
  data: U
) {
  return ApiService.fetchData<T>({
    url: `api/shreds/${shredId}/validate`,
    method: 'post',
    data,
  })
}

export async function apiGeneratePlan<T, U extends Record<string, unknown>>(
  shredId: string,
  data: U
) {
  return ApiService.fetchData<T>({
    url: `api/shreds/${shredId}/plan`,
    method: 'post',
    data,
  })
}

export async function apiRegeneratePlan<T>(
  shredId: string
) {
  return ApiService.fetchData<T>({
    url: `api/shreds/${shredId}/plan`,
    method: 'put',
  })
}

export async function apiUpdatePlan<T, U extends Record<string, unknown>>(
  shredId: string,
  data: U
) {
  return ApiService.fetchData<T>({
    url: `api/shreds/${shredId}/update_plan`,
    method: 'post',
    data,
  })
}

export async function apiDeleteShred(
  shredId:string
){
  return ApiService.fetchData<ShredResponse>({
    url: `api/shreds/${shredId}`,
    method: 'delete'
  })
}

export async function apiGenerateShred(
  shredId: string
) {
  return ApiService.fetchData<ShredResponse>({
    url: `api/shreds/${shredId}/generate`,
    method: 'post',
  })
}

export async function apiValidateShredForGeneration(
  shredId: string
) {
  return ApiService.fetchData<ShredResponse>({
    url: `api/shreds/${shredId}/validate`,
    method: 'get',
  })
}

export async function apiRegenerateShred(
  shredId: string
) {
  return ApiService.fetchData<ShredResponse>({
    url: `api/shreds/${shredId}/resume/true/STEP_GENERATE_SHRED_SUMMARY_AND_METADATA`,
    method: 'post',
  })
}

export async function apiResumeShredGeneration(
  shredId: string
) {
  return ApiService.fetchData<ShredResponse>({
    url: `api/shreds/${shredId}/resume/true`,
    method: 'post',
    headers: {
      accept: 'application/json',
    }
  })
}

export async function apiGenerateShredPrompt(
  shredId: string,
) {
  return ApiService.fetchData<GenerateShredPromptResponse>({
    url: `api/shreds/${shredId}/generate_entries`,
    method: 'post',
  })
}

export async function apiGetShredPrompt(
  shredId: string,
) {
  return ApiService.fetchData<GenerateShredPromptResponse>({
    url: `api/shreds/${shredId}/get_entries`,
    method: 'get',
  })
}

export async function apiCommentsReview(
  shredId: string,
  compileAfterEnd: boolean
) {
  return ApiService.fetchData<void>({
    url: `api/shreds/${shredId}/comments/${compileAfterEnd}`,
    method: 'get',
  })
}
